<template>
  <div class="bikelist-container">
    <el-form :model="queryInfo" size="medium" :inline="true">
      <el-form-item :label="$t('finance.name1')" prop="tenantId" >
          <el-select v-model="queryInfo.tenantId" :placeholder="$t('public.name1')" clearable>
    <el-option
      v-for="item in tenantOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
        </el-form-item>
            <el-form-item :label="$t('screen.name2')" prop="title">
              <el-input v-model="queryInfo.title" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" size="medium" @click="getDataList">{{ $t('public.name3') }}</el-button>
            <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
          </el-form-item>
    </el-form>
    <div><el-button type="primary" @click="addTravel(null)">{{ $t('screen.name95') }}</el-button></div>
    <el-table ref="table"   :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('bike.name105')" prop="tenantName" sortable width="180px"></el-table-column>
      <el-table-column :label="$t('screen.name3')" prop="title" sortable width="180px"></el-table-column>
      <el-table-column :label="$t('bike.name190')" prop="createrName" sortable width="180px"> </el-table-column>
      <el-table-column :label="$t('bike.name191')" prop="createrId" sortable width="180px"></el-table-column>
      <el-table-column :label="$t('bike.name192')" prop="travelId" sortable width="180px"></el-table-column>
      <el-table-column :label="$t('bike.name193')" prop="createTime" sortable width="180px" ></el-table-column>
      <el-table-column :label="$t('bike.name194')" prop="updateTime" sortable width="180px"></el-table-column>
      <el-table-column :label="$t('bike.name195')" prop="origin" sortable width="180px"></el-table-column>
      <el-table-column :label="$t('bike.name196')" prop="dest" sortable width="180px"></el-table-column>
      <el-table-column :label="$t('bike.name197')" prop="distance" sortable width="180px"></el-table-column>
      <el-table-column :label="$t('bike.name198')" prop="travelType" sortable width="180px">
        <template slot-scope="scope">
         <div>{{ ['',$t('bike.name199'),$t('bike.name200')][scope.row.travelType] }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name201')" prop="difficulty" sortable width="180px" ></el-table-column>
      <el-table-column :label="$t('finance.name11')" prop="remark" sortable width="180px"></el-table-column>
      <el-table-column :label="$t('bike.name11')" width="140px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="addTravel(scope.row)">{{ $t('finance.name16') }}</el-button>
          <el-button type="text" @click="delList(scope.row)" style="color:#ea4646">{{ $t('operate.name25') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
     <!--添加路书-->
     <el-dialog :title="$t('bike.name202')" :visible.sync="travelDialog" v-if="travelDialog" :close-on-click-modal ="false" :before-close="close" width="600px">
      <el-form ref="travelFormRef" label-width="100px" :rules="travelFormRules" :model="travelInfo" class="width100">
        <el-form-item :label="$t('finance.name1')" prop="tenantId" >
          <el-select v-model="travelInfo.tenantId" :placeholder="$t('public.name1')" style="width:100%">
    <el-option
      v-for="item in tenantOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
        </el-form-item>
        <el-form-item :label="$t('screen.name2')" prop="title" >
          <el-input v-model="travelInfo.title" :placeholder="$t('public.name5')" clearable class="width100" > </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name203')" prop="origin" >
          <el-input v-model="travelInfo.origin" :placeholder="$t('public.name5')" clearable class="width100" > </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name204')" prop="dest" >
          <el-input v-model="travelInfo.dest" :placeholder="$t('public.name5')" clearable class="width100" > </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name205')" prop="distance" >
          <el-input v-model="travelInfo.distance" :placeholder="$t('public.name5')" clearable class="width100" > </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name206')" prop="difficulty" >
          <el-rate v-model="travelInfo.difficulty" :colors="colors"></el-rate>
        </el-form-item>
        <el-form-item :label="$t('bike.name207')" prop="traffic" >
          <el-rate v-model="travelInfo.traffic" :colors="colors"></el-rate>
        </el-form-item>
        <el-form-item :label="$t('bike.name208')" prop="calories">
          <el-input-number v-model="travelInfo.calories" :min="0" ></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('bike.name209')" prop="estimated">
          <el-input-number v-model="travelInfo.estimated" :min="0" ></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('bike.name210')" prop="cover">
          <div class="upload-layout">
                <el-upload class="avatar-uploader" action  :http-request="(e) => {handleUpLoadFile(e)}" :show-file-list="false">
                  <img v-if="travelInfo.cover" :src="travelInfo.cover" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
        </el-form-item>
        <el-form-item :label="$t('bike.name211')" prop="trackList" >
        </el-form-item>
        <el-form-item :label="$t('finance.name20')" prop="remark" >
          <el-input v-model="travelInfo.remark" :placeholder="$t('public.name5')" clearable class="width100" > </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { findTravelPlanPage, removeTravelPlan, saveTravelPlan, modifyTravelPlan } from '@/api/bike.js'
import { uploadFile, tenantList } from '@/api/manage.js'
export default {
  data() {
    return {
      searchTime: [],
      queryInfo: {
        title: '',
        tenantId: '',
        pageNumber: 1,
        pageSize: 10
      },
      tenantOptions: [],
      total: 0,
      tableList: [],
      tableLoading: false,
      travelDialog: false,
      travelFormRules: {
        tenantId: [
          {
            required: true,
            message: '请选择商户',
            trigger: 'blur'
          }
        ],
        title: [
          {
            required: true,
            message: '请输入标题',
            trigger: 'blur'
          }
        ],
        cover: [
          {
            required: true,
            message: '请选择封面图',
            trigger: 'blur'
          }
        ]
      },
      loading: false,
      travelInfo: {
        tenantId: '',
        travelId: '',
        title: '',
        origin: '',
        dest: '',
        distance: '',
        difficulty: 0,
        traffic: 0,
        calories: 0,
        estimated: 0,
        remark: '',
        cover: '',
        trackList: []
      },
      colors: ['#99A9BF', '#F7BA2A', '#FF9900']
    }
  },
  components: {},
  created() {
    this.getDataList()
    this.loadOptions()
  },
  mounted() {},
  computed: {},
  methods: {
    loadOptions() {
      const data = { page: 1, limit: 500, tenantType: 2 }
      tenantList(data).then(res => {
        if (res.data.list) {
          this.tenantOptions = res.data.list.map(item => ({
            value: item.tenantId,
            label: item.tenantName
          }))
        } else {
          this.tenantOptions = []
        }
      }).catch(() => {})
    },
    getDataList() {
      this.tableLoading = true
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      if (this.queryInfo.title) {
        this.queryInfo.title = this.queryInfo.title.trim()
      }
      findTravelPlanPage(this.queryInfo).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.tableList = res.data.travelPlanPage.records
          this.total = res.data.travelPlanPage.total
        }
      }).catch(() => {
        this.tableLoading = false
      })
    },
    getFindTravelPlanPage() {
      this.tableLoading = true
      if (this.queryInfo.title) {
        this.queryInfo.title = this.queryInfo.title.trim()
      }
      findTravelPlanPage(this.queryInfo).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.tableList = res.data.travelPlanPage.records
          this.total = res.data.travelPlanPage.total
        }
      }).catch(() => {
        this.tableLoading = false
      })
    },
    resetQuery() {
      this.queryInfo = {
        title: '',
        tenantId: '',
        pageNumber: 1,
        pageSize: 10
      }
      this.getFindTravelPlanPage()
    },
    delList(row) {
      this.$confirm('您确定删除该条路书吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          removeTravelPlan({ travelId: row.travelId }).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.queryInfo.pageNumber = 1
              this.getDataList()
            }
          }).catch(() => {})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handleUpLoadFile(param) {
      const formData = new FormData()
      formData.append('multipart', param.file)
      const loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      uploadFile(formData)
        .then(res => {
          loading.close()
          if (res.code === 200) {
            this.travelInfo.cover = res.data.fileUrl
            this.$message.success('上传成功')
          }
        })
        .catch(res => {
          loading.close()
        })
    },
    close() {
      this.travelDialog = false
      this.travelInfo = {
        title: '',
        origin: '',
        dest: '',
        distance: '',
        difficulty: '',
        traffic: '',
        calories: 0,
        estimated: 0,
        remark: '',
        cover: '',
        trackList: []
      }
    },
    addTravel(row) {
      if (row !== null) {
        this.travelInfo = {
          title: row.title,
          origin: row.origin,
          dest: row.dest,
          distance: row.distance,
          difficulty: row.difficulty,
          traffic: row.traffic,
          calories: row.calories,
          estimated: row.estimated,
          remark: row.remark,
          cover: row.cover,
          travelId: row.travelId,
          tenantId: row.tenantId,
          trackList: []
        }
      } else {
        this.travelInfo.tenantId = this.tenantOptions[0].value
      }
      this.travelDialog = true
    },
    submitForm() {
      this.$refs.travelFormRef.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        if (this.travelInfo.travelId) {
          modifyTravelPlan(this.travelInfo)
            .then((res) => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.getDataList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          saveTravelPlan(this.travelInfo)
            .then((res) => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.getDataList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getFindTravelPlanPage()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.getFindTravelPlanPage()
    }
  }
}
</script>

<style lang="scss">
.el-input-number{
  line-height: 34px;
}
.avatar-uploader {
  width: 100px;
  height: 100px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: 100px;
  height: 100px;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
</style>
<style lang="scss" scoped>
.bikelist-container {
  display: flex;
  flex-direction: column;
  .top{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .upload-layout {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 120px;

    .avatar {
      width: 100px;
      height: 100px;
    }
    > :last-child {
      margin-left: 10px;
      font-size: 12px;
      color: #555;
      // line-height: 16.8px;
    }
  }
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
  .title-style{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title{
      width: 50%;
      text-align: center;
    }
  }

  .date-picker{
    display: flex;
    flex-direction: row;
   .search-bt{
      margin-left: 25px;
    }
  }

  .file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }

  .green {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;
  }

  .red {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;
  }
}
</style>
